<template>
    <div>
        <!-- ============= COMPONENT ============== -->
        <nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top py-2">
            <div class="container-fluid mt-3 mb-3">
                <div class="navbar-brand text-info"><img :src="logo_url" alt="ja-alimentação"  style="width:60px"></div>


                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main_nav"
                        aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>


                <div class="vr mt-3 mb-3 d-none d-lg-block"></div>

                <div class="collapse navbar-collapse justify-content-end" id="main_nav">
                    <ul class="navbar-nav me-auto mt-3 mt-lg-0" v-if="is_auth && !publicRoutes.includes(atual_route_name)">

                        <li class="nav-item active px-lg-2"><a class="nav-link" :href="home_route">Home </a></li>

                        <!-- -------- movimentos -------- -->
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#"  @click.prevent="" data-bs-toggle="dropdown"> Movimentos </a>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="#" @click.prevent="">Importar<i class="icon-arrow"></i> </a>
                                    <ul class="submenu dropdown-menu">
                                        <li><a class="dropdown-item" :href="customer_employees_route" >Colaboradores</a></li>
                                        <li><a class="dropdown-item" :href="daily_menu_route" >Refeições</a>
                                        </li>
                                    </ul>
                                </li>
                                <li><a class="dropdown-item" :href="order_customer_employees_confirm_register_route" >Pedidos de Refeições<i class=""></i> </a></li>
                            </ul>
                        </li>
                        <!-- -------- movimentos end -------- -->

                        <!-- -------- relatórios -------- -->
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#" @click.prevent="" data-bs-toggle="dropdown">Relatórios</a>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="#" @click.prevent="">Refeições<i class="icon-arrow"></i> </a>
                                    <ul class="submenu dropdown-menu">
                                        <li><a class="dropdown-item" :href="order_customer_employees_daily_report_index_route" >Refeições Diárias</a></li>
                                    </ul>
                                </li>

                            </ul>
                        </li>
                        <!-- -------- relatórios end -------- -->

                        <!-- -------- consultas -------- -->
<!--                        <li class="nav-item dropdown">-->
<!--                            <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" @click.prevent=""> Consultas </a>-->
<!--                            <ul class="dropdown-menu">-->
<!--                                <li><a class="dropdown-item" href="#" @click.prevent="">Dados do cliente</a></li>-->
<!--                                <li><a class="dropdown-item" href="#" @click.prevent="">Preço de venda</a></li>-->
<!--                                <li><a class="dropdown-item" href="#" @click.prevent="">Códigos personalizados</a></li>-->
<!--                            </ul>-->
<!--                        </li>-->
                        <!-- -------- consultas end -------- -->
                    </ul>


                    <!--user menu-->
                    <div class="navbar-nav" v-if="is_auth">
                        <div class="nav-item dropdown mt-3 mt-lg-0">
                            <button data-bs-toggle="dropdown" class="btn btn-outline-warning dropdown-toggle"
                                    type="button">
                                {{ this.username }}
                            </button>
                            <div class="dropdown-menu dropdown-menu-end">
                                <div class="px-4 py-3" style="min-width:250px">
                                    <p><a class="dropdown-item" href="#"> Meus Dados</a></p>
                                    <p><a class="dropdown-item" href="#">Alerar Senha</a></p>
                                    <hr class="">
                                    <p><a class="dropdown-item" :href="logout_route" @click.prevent="logout">Logout</a>
                                    </p>
                                    <form id="logout-form" :action="logout_route" method="POST" class="d-none">
                                        <input type="hidden" name="_token" :value="csrf_token">
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="navbar-nav" v-if="!is_auth && !publicRoutes.includes(atual_route_name)" >
                        <ul class="navbar-nav me-auto mt-3 mt-lg-0">
                            <li class="nav-item active"><a class="nav-link" :href="login_route">Logar</a></li>
                            <li class="nav-item active"><a class="nav-link" :href="register_route">Cadastrar</a></li>
                        </ul>
                    </div>
                    <div class="navbar-nav" v-if="!is_auth  && publicRoutes.includes(atual_route_name) && atual_route_name !== 'order-customer-employees.confirm-register' " >
                        <ul class="navbar-nav me-auto mt-3 mt-lg-0">
                            <li class="nav-item active"><a class="nav-link" :href="employees_logout_route">Sair</a></li>
                        </ul>
                    </div>
                    <!--user menu end-->


                </div> <!-- navbar-collapse.// -->
            </div> <!-- container-fluid.// -->
        </nav>
        <!-- ============= COMPONENT END// ============== -->
    </div>
</template>

<script>


export default {
    name: "MenuKitComponent",
    props: [
        'is_auth', 'csrf_token', 'username', 'logout_route',
        'login_route', 'register_route','logo_url','home_route', 'customer_employees_route', 'daily_menu_route',
        'atual_route_name','employees_logout_route','order_customer_employees_confirm_register_route',
        'order_customer_employees_daily_report_index_route'
    ],

    computed:{
        publicRoutes(){
            return [
                'order-customer-employees.confirm-register', 'order-customer-employees.index',
                'order-customer-employees.index-finish-order'
            ]
        }

    },
    methods: {
        logout() {
            $('#logout-form').submit();
        }
    },
}
</script>

<style scoped>

</style>
